export const companySizeList = [
    "1-10 employees",
    "10-30 employees",
    "30-70 employees",
    "70-100 employees",
    "100+ employees"
]

export const title = "PetsMates"

// Canonical origin for the site. Kept fixed rather than read from the request
// host so a preview deployment can never declare itself the canonical version
// of a production page.
export const SITE_ORIGIN = "https://petsmates.au"